import { FC } from "react";

import {
  FloatingMenuGrid,
  TableWrapperGeneric,
  TopHeaderCalendar,
} from "@ryde/controls";
import {
  BulkOperationsDrawerGeneric,
  BulkUpdateFormDrawer,
  FinalSchemaService,
  PageHeader,
  PageHeaderFilters,
  PanelTop,
  TableSettingsDrawerWrapperGeneric,
} from "@ryde/layout";
import { PageHeaderContext } from "@ryde/redux";
import {
  IColumnDef,
  IExtendableDto,
  ITableDto,
  TopCalendarMode,
} from "@ryde/shared";

import { NotificationsCustomHeaderRight } from "../header";
import { useNotificationsPage } from "./hooks";
import { NotificationsFloatingElements } from "./notifications.floating.elements";

export const NotificationsPageMain: FC = () => {
  const {
    entity,
    pageTitleTranslated,
    tableDefsGeneric,
    tableSettingsDrawerOpened,
    bulkOperationsDrawerOpened,
    bulkUpdateFormDrawerOpened,
    selectedIds,
    notificationHeaderContextValue,
  } = useNotificationsPage();

  return (
    <>
      <FinalSchemaService />
      <PageHeader
        mainTitle={pageTitleTranslated}
        topWidgetComponent={
          <TopHeaderCalendar
            entity={entity}
            defaultMode={TopCalendarMode.LAST_30_DAYS}
          />
        }
        bottomWidgetComponent={<PanelTop />}
        customRightComponent={<NotificationsCustomHeaderRight />}
      >
        <PageHeaderContext.Provider value={notificationHeaderContextValue}>
          <PageHeaderFilters />
        </PageHeaderContext.Provider>
      </PageHeader>
      <TableWrapperGeneric
        tableDefs={tableDefsGeneric as IColumnDef<IExtendableDto, unknown>[]}
      />

      {tableSettingsDrawerOpened && (
        <TableSettingsDrawerWrapperGeneric<ITableDto>
          tableDefs={tableDefsGeneric}
        />
      )}
      {bulkOperationsDrawerOpened && <BulkOperationsDrawerGeneric />}
      {selectedIds && (
        <FloatingMenuGrid elements={<NotificationsFloatingElements />} />
      )}
      {bulkUpdateFormDrawerOpened && <BulkUpdateFormDrawer />}
    </>
  );
};
